<template>
  <div>
    <notifications group="push-notification" :duration="4500" :width="360" position="bottom right" ref="pushNotification">
      <template slot="body" slot-scope="props">
        <div :class="['push-notification', 'c-pointer', infoTypeCssClass[props.item.type]]" @click="onPushNotificationClick(props)">
          <!-- header -->
          <div class="header">
            <span>
              <span class="title">{{ props.item.title }}</span>
              <span class="date">{{ getDateToString(new Date()) }}</span>
            </span>
            <span class="tool">
              <i class="c-pointer fal fa-cog mr-r2" @click="onSettingButtonClick(props.item, $event)"></i>
              <i class="c-pointer fal fa-times" @click="onCloseButtonClick(props, $event)"></i>
            </span>
          </div>
          <div class="body">
            <!-- 푸시알림 정보 영역 -->
            <span v-show="!props.item.data.showSetting">{{ props.item.text }}</span>
            <!-- 푸시알림 수신여부 설정 영역-->
            <div v-show="props.item.data.showSetting">
              <el-row>
                <el-switch v-model="props.item.data.settingInfo.globalReceiveFlag" active-value="Y" inactive-value="N"></el-switch>
                 전체 푸시 알림 수신 여부
              </el-row>
              <el-row>
                <el-switch v-model="props.item.data.settingInfo.receiveFlag" :disabled="props.item.data.settingInfo.globalReceiveFlag === 'N'" active-value="Y" inactive-value="N"></el-switch>
                 {{ `[${props.item.title}] 푸시 알림 수신 여부` }}
              </el-row>
            </div>
          </div>
          <div class="footer" v-show="props.item.data.showSetting">
            <el-button size="mini" type="solid" class="mr-r4" @click="onSaveButtonClick(props.item)">저장</el-button>
            <el-button size="mini" @click="onCloseSettingButtonClick(props.item, $event)">취소</el-button>
          </div>
        </div>
      </template>
    </notifications>

    <!-- 사용자 팝업 (쪽지/공지사항) -->
    <w-user-sliding-popup ref="userSlidingPopup" />
  </div>
</template>

<script>
import moment from 'moment';
import { isEmpty } from 'lodash';
import { infoType } from '@/constants/push-notification';
import { booleanDefine } from '@/utils/boolean';
import { getDateToString } from '@/utils/date';
import { routeMap } from '@/utils/router';
import msgUtil from '@/utils/message';
import pushNotificationApi from '@/api/frame/push-notification';
import WUserSlidingPopup from './popup/UserSlidingPopup';

export default {
  name: 'WPushNotification',
  components: {
    WUserSlidingPopup,
  },
  data() {
    return {
      popupParams: {
        eventHistInfo: {},
        regularCheckDetailInfo: {},
        changeConfigInfo: {},
      },
      infoTypeCssClass: {
        [infoType.EVENT]: 'danger',
        [infoType.PREDICT_EVENT]: 'danger',
        [infoType.CHANGE_CONFIG]: 'warning',
        [infoType.REGULAR_CHECK]: 'warning',
        [infoType.PLANNDED_WORK]: 'info',
        [infoType.CHANGE_WORK]: 'info',
        [infoType.MESSAGE]: 'info',
        [infoType.NOTICE]: 'info',
        [infoType.CHANGE_TOPOLOGYMAP]: 'info',
      },
    };
  },
  methods: {
    getDateToString,
    /**
     * 푸시 알림 메세지 정보 설정
     * @author jeee12
     * @param  {[type]} messageInfo [description]
     */
    setPushNofiticationMessage(messageInfo) {
      this.$pushNotification({
        group: 'push-notification',
        type: messageInfo.infoType,
        title: messageInfo.title,
        text: messageInfo.message,
        data: {
          showSetting: false,
          settingInfo: {
            receiveFlag: booleanDefine.TRUE_Y,
            globalReceiveFlag: booleanDefine.TRUE_Y,
          },
          ...messageInfo.params,
        },
      });
    },
    /**
     * 푸시 알림 클릭
     * @author jeee12
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    onPushNotificationClick(props) {
      if (props.item.data.showSetting) return;

      const type = props.item.type;
      const params = props.item.data;

      if (type === infoType.EVENT || type === infoType.PREDICT_EVENT) {
        this.linkToEventHistPopup(type, params);
      } else if (type === infoType.CHANGE_CONFIG) {
        this.linkToChangeConfigPopup(type, params);
      } else if (type === infoType.REGULAR_CHECK) {
        this.linkToRegularCheckPopup(params);
      } else if (type === infoType.PLANNDED_WORK) {
        this.linkToPlannedWorkPopup();
      } else if (type === infoType.CHANGE_WORK) {
        this.linkToChangeWorkPopup(type, params);
      } else if (type === infoType.MESSAGE || type === infoType.NOTICE) {
        this.linkToUserPopup(type);
      } else {
        this.routeToTopologyMap(params);
      }

      // 기능 연계 수행 후 푸시 알림 종료
      this.onCloseButtonClick(props);
    },
    /**
     * 푸시 알림 닫기 버튼 클릭
     * @author jeee12
     * @param  {[type]} props [description]
     * @param  {[type]} event [description]
     */
    onCloseButtonClick(props, event) {
      props.close();
      if (!isEmpty(event)) {
        event.stopPropagation();
      }
    },
    /**
     * 푸시 알림 설정 버튼 클릭
     * @author jeee12
     * @param  {[type]} item [description]
     * @param  {[type]} event [description]
     */
    onSettingButtonClick(item, event) {
      const isInfoView = !item.data.showSetting;
      if (isInfoView) {
        // 정보 -> 설정으로 전환시 알림창 유지 timeout 해제
        clearTimeout(item.timer);
        item.timer = null;
        item.data.showSetting = true;
      } else {
        // 설정 -> 정보로 전환
        this.onCloseSettingButtonClick(item, event);
      }
    },
    /**
     * 푸시 알림 설정 닫기 버튼 클릭
     * @author jeee12
     * @param  {[type]} item [description]
     * @param  {[type]} event [description]
     */
    onCloseSettingButtonClick(item, event) {
      const pushNotification = this.$refs.pushNotification;
      item.timer = setTimeout(() => { // 알림창 timeout 재설정
        pushNotification.destroy(item);
      }, 4500);
      item.data.showSetting = false;

      if (!isEmpty(event)) {
        event.stopPropagation();
      }
    },
    /**
     * 푸시 알림 설정 저장 버튼 클릭
     * @author jeee12
     * @param  {[type]} item [description]
     */
    onSaveButtonClick(item) {
      const infoTypeId = item.type;
      const params = {
        GLOBAL: item.data.settingInfo.globalReceiveFlag,
        [infoTypeId]: item.data.settingInfo.receiveFlag,
      };
      const target = '푸시 알림 수신 여부 설정';
      const action = msgUtil.action.MODIFY;

      pushNotificationApi.updatePushNotificationReceiveFlagSetting(params).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getResultMsgData(action, target, true));
          this.onCloseSettingButtonClick(item);
        } else {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
        throw new Error(e);
      });
    },
    /**
     * 푸시 알림 모두 제거
     * @author jeee12
     * @return {[type]} [description]
     */
    cleanPushNotification() {
      this.$pushNotification({
        group: 'push-notification',
        clean: true,
      });
    },
    /**
     * 푸시 알림 > 이벤트, 사전예측이벤트 팝업 연계
     * @author jeee12
     * @param  {[type]} type   푸시 알림 type
     * @param  {[type]} params 푸시 알림 params
     */
    linkToEventHistPopup(type, params) {
      this.$store.dispatch('openCommonEventHistPopup', { type, ...params });
    },
    /**
     * 푸시 알림 > 구성 정보 변경 팝업 연계
     * @author jeee12
     * @param  {[type]} type   푸시 알림 type
     * @param  {[type]} params 푸시 알림 params
     */
    linkToChangeConfigPopup(type, params) {
      const changeConfigInfo = {
        timelineType: 'CONFIG_CHANGE',
        objIds: [params.objId],
        timestamp: params.checkDatetime,
        timelineTypeName: '구성 변경',
        timelineTarget: params.objName,
      };
      this.$store.dispatch('openEventTimelinePopup', changeConfigInfo);
    },
    /**
     * 푸시 알림 > 정기점검 항목 변경 팝업 연계
     * @author jeee12
     * @param  {[type]} type   푸시 알림 type
     * @param  {[type]} params 푸시 알림 params
     */
    linkToRegularCheckPopup(params) {
      this.$store.dispatch('openRegularCheckDetailInfoPopup', params);
    },
    /**
     * 푸시 알림 > 예정 작업 팝업 연계
     * @author jeee12
     * @param  {[type]} type   푸시 알림 type
     * @param  {[type]} params 푸시 알림 params
     */
    linkToPlannedWorkPopup() {
      const startDateTime = moment();
      const endDateTime = moment(startDateTime).add(1, 'days');
      const param = {
        startDatetime: startDateTime.toDate().getTime(),
        endDatetime: endDateTime.toDate().getTime(),
      };
      this.$store.dispatch('openWorkDetailPopup', param);
    },
    /**
     * 푸시 알림 > 작업 변경 팝업 연계
     * @author jeee12
     * @param  {[type]} type   푸시 알림 type
     * @param  {[type]} params 푸시 알림 params
     */
    linkToChangeWorkPopup(type, params) {
      this.$store.dispatch('openWorkDetailsSlidingPopup', { viewTypeTimeLine: true, ...params });
    },
    /**
     * 푸시 알림 > 쪽지/공지사항 팝업 연계
     * @author jeee12
     * @param  {[type]} type   푸시 알림 type
     * @param  {[type]} params 푸시 알림 params
     */
    linkToUserPopup(type) {
      this.$store.dispatch('openUserPopup', type.toLowerCase());
    },
    /**
     * 푸시 알림 > 토폴로지 맵 라우터 이동
     * @author jeee12
     * @param  {[type]} type   푸시 알림 type
     * @param  {[type]} params 푸시 알림 params
     */
    routeToTopologyMap(params) {
      const mapId = params.mapId;
      routeMap(this, mapId);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/frame/components/PushNotification.vue